/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareRoundedLetterC = createReactComponent(
  "square-rounded-letter-c",
  "IconSquareRoundedLetterC",
  [
    ["path", { d: "M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0", key: "svg-0" }],
    [
      "path",
      {
        d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z",
        key: "svg-1"
      }
    ]
  ]
);

export { IconSquareRoundedLetterC as default };
//# sourceMappingURL=IconSquareRoundedLetterC.js.map
